TranslationModalService.$inject = ['ModalService'];

export function TranslationModalService(ModalService) {
  var service = {
    open: openModal,
  };

  return service;

  ////////////////

  function openModal(templateUrl, modalParams, initializeCallback, confirmCallback) {
    ModalService.showModal({
      templateUrl: templateUrl,
      controller: TranslationModalCtrl,
      controllerAs: 'vm',
      inputs: {
        modalParams: modalParams,
        initializeCallback: initializeCallback,
        confirmCallback: confirmCallback,
      },
    }).then(function (modal) {
      var preventModalClose = {
        backdrop: 'static',
        keyboard: false,
      };

      modal.element.modal(preventModalClose);
    });

    TranslationModalCtrl.$inject = [
      'UtilService',
      'modalParams',
      'initializeCallback',
      'confirmCallback',
    ];
  }

  function TranslationModalCtrl(UtilService, modalParams, initializeCallback, confirmCallback) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // If specified, fill window parameters
    vm.modalTitle = modalParams.title || '';

    //vm.parentId = modalParams.parentId || ''; // what for?

    vm.additionalLanguages = modalParams.additionalLanguages;

    vm.getContent = getContent;
    vm.updateItem = updateItem;

    function getContent(language) {
      initializeCallback(modalParams.item.id, language).then(function (data) {
        vm.item = data;

        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);
      });
    }

    function updateItem(isFormValid, language) {
      vm.formErrors = false;

      var to = 'translation_form';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop(to);
      } else {
        vm.sendingForm = true;
        setTimeout(function () {
          // Delay x sec
          confirmCallback(vm.item, language).then(function (response) {
            if (response.errors) {
              vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

              vm.formErrors = true;
              vm.UtilService.scrollToTop(to);
            }
          });

          vm.sendingForm = false;
        }, 300);
      }
    }
  }
}
